import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  SadieSimulatorDigest,
  SadieSimulatorDigestRequest,
} from "@/types";

export function useSimulateSadieDigest() {
  return useMutation({
    mutationFn: async (request: SadieSimulatorDigestRequest) => {
      const res = await guacHttpClient.post<
        SadieSimulatorDigest,
        HttpResponse<SadieSimulatorDigest>
      >("relationships/simulate/digest", request);
      return res.data;
    },
  });
}
